'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var moduleName = 'appRun';

angular.module(moduleName, [])
    .run(['$rootScope', '$location', '$http', '$window', 'AuthenticationService', require('./run/login')])
    .run(['$rootScope', require('./run/logout')])
;

exports.default = moduleName;
module.exports = exports['default'];



/** WEBPACK FOOTER **
 ** ./js/run.js
 **/